import { Bling } from './bling';

function coopToggle(triggers) {
    if (!triggers) { return }
    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();

            const $this = this;
            const target = trigger.getAttribute('href');
            const triggerText = $this.getAttribute('data-toggle-text');
            const triggerInnerText = $this.innerText;

            $this.innerText = triggerText;
            $this.setAttribute('data-toggle-text', triggerInnerText);
            Bling.$(target).classList.toggle('coop-u-visuallyhidden');

            if (Bling.$(target).offsetHeight > 0) {
                Bling.$(target).setAttribute('aria-hidden', 'false')
                Bling.$(target).setAttribute('aria-expanded', 'true')
                Bling.$(target).setAttribute('aria-live', 'polite')
            } else {
                Bling.$(target).setAttribute('aria-hidden', 'true')
                Bling.$(target).removeAttribute('aria-expanded')
                Bling.$(target).removeAttribute('aria-live')
            }
        });
    });
}

export default coopToggle;
